module.exports = __webpack_public_path__ + "img/kkb_power.9d3586b1.png";